import React, { useState, useEffect } from 'react';
import { getPendingVoters } from '../utils/offlineDB';
import { syncPendingVoters } from '../utils/syncOfflineData';
import toast from 'react-hot-toast';

export default function OfflineBanner() {
  const [online, setOnline] = useState(navigator.onLine);
  const [pendingCount, setPendingCount] = useState(0);
  const [syncing, setSyncing] = useState(false);

  useEffect(() => {
    const goOnline  = () => { setOnline(true);  checkPending(); autoSync(); };
    const goOffline = () => setOnline(false);
    window.addEventListener('online',  goOnline);
    window.addEventListener('offline', goOffline);
    checkPending();
    return () => { window.removeEventListener('online', goOnline); window.removeEventListener('offline', goOffline); };
  }, []);

  const checkPending = async () => { try {
    const p = await getPendingVoters();
    setPendingCount(p.length); } catch(e) { console.log("IndexedDB error:", e); }
  };

  const autoSync = async () => {
    const pending = await getPendingVoters();
    if (pending.length > 0) handleSync();
  };

  const handleSync = async () => {
    setSyncing(true);
    try {
      const result = await syncPendingVoters();
      if (result.synced > 0) {
        toast.success(`✅ ${result.synced} offline voter${result.synced>1?'s':''} synced to server!`, { duration: 5000 });
        setPendingCount(0);
      }
      if (result.failed > 0) toast.error(`⚠️ ${result.failed} voters failed to sync`);
    } catch { toast.error('Sync failed'); }
    finally { setSyncing(false); }
  };

  if (online && pendingCount === 0) return null;

  return (
    <div style={{
      position: 'fixed', bottom: 80, left: '50%', transform: 'translateX(-50%)',
      zIndex: 999, minWidth: 280, maxWidth: '90vw',
      background: online ? 'linear-gradient(135deg,#1B5E20,#2E7D32)' : 'linear-gradient(135deg,#B71C1C,#E53935)',
      color: 'white', borderRadius: 16, padding: '12px 18px',
      display: 'flex', alignItems: 'center', gap: 10,
      boxShadow: '0 8px 32px rgba(0,0,0,0.3)',
      fontFamily: "'Outfit',sans-serif",
      animation: 'slideUp 0.4s ease',
    }}>
      <span style={{ fontSize: '1.3rem' }}>{online ? '🟢' : '📴'}</span>
      <div style={{ flex: 1 }}>
        {!online ? (
          <><div style={{ fontWeight: 700, fontSize: '0.88rem' }}>No Internet Connection</div>
          <div style={{ fontSize: '0.72rem', opacity: .85 }}>New enrollments saved offline{pendingCount > 0 ? ` • ${pendingCount} pending` : ''}</div></>
        ) : (
          <><div style={{ fontWeight: 700, fontSize: '0.88rem' }}>Back Online! 🎉</div>
          <div style={{ fontSize: '0.72rem', opacity: .85 }}>{pendingCount} voter{pendingCount>1?'s':''} ready to sync</div></>
        )}
      </div>
      {online && pendingCount > 0 && (
        <button onClick={handleSync} disabled={syncing} style={{ background: 'rgba(255,255,255,0.2)', border: '1.5px solid rgba(255,255,255,0.4)', color: 'white', padding: '6px 14px', borderRadius: 99, cursor: 'pointer', fontWeight: 700, fontSize: '0.78rem', fontFamily: "'Outfit',sans-serif", whiteSpace: 'nowrap' }}>
          {syncing ? '⏳ Syncing...' : '🔄 Sync Now'}
        </button>
      )}
    </div>
  );
}